import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const productAREApi = createApi({
  reducerPath: "productAREApi",
  baseQuery,
  tagTypes: ["AREDetails"],
  
  endpoints: (builder) => ({
    // ✅ Get ARE details by exportProductId
    getProductAREById: builder.query({
      query: (exportProductId) => `/export/product/areDetails/${exportProductId}`,
      transformResponse: (response) => response?.data ?? [],
      providesTags: ["AREDetails"],
    }),

    // ✅ Create new ARE details
    createARE: builder.mutation({
      query: ({ exportProductId, exportAreDetails }) => ({
        url: `/export/product/areDetails/${exportProductId}`,
        method: "PUT",
        body: { exportAreDetails },
      }),
      invalidatesTags: ["AREDetails"],
    }),

    // ✅ Update existing ARE details
    updateARE: builder.mutation({
      query: ({ exportProductId, areDetailsId, exportAreDetails }) => ({
        url: `/export/product/areDetails/${exportProductId}/${areDetailsId}`,
        method: "PUT",
        body: { exportAreDetails },
      }),
      invalidatesTags: ["AREDetails"],
    }),

    // ✅ Delete ARE details
    deleteARE: builder.mutation({
      query: ({ areDetailsId }) => ({
        url: `/export/product/areDetails/${areDetailsId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["AREDetails"],
    }),
  }),
});

export const {
  useGetProductAREByIdQuery,
  useCreateAREMutation,
  useUpdateAREMutation,
  useDeleteAREMutation,
} = productAREApi;
